export const ViewMode = {
  Hour: "Hour",
  QuarterDay: "Quarter Day",
  HalfDay: "Half Day",
  Day: "Day",
  Week: "Week",
  Month: "Month",
  QuarterYear: "QuarterYear",
  Year: "Year"
};

export const TaskType = {
  Task: "Task",
  Milestone: "Milestone"
};